import {Show, ShowProps, SimpleShowLayout} from "ra-ui-materialui";
import React from "react";
import {CommentSection, DebtCollectionDetails} from "./DebtCollectionDetails";

export const DebtColletionShow = (props: ShowProps) => {
  return (
    <Show {...props}>
        <SimpleShowLayout>
            <DebtCollectionDetails />
            <CommentSection />
        </SimpleShowLayout>
    </Show>
  );
};
